import axios from "axios";
import qs from "qs";
import { toast } from "react-toastify";
import { baseUrl } from "../config";
console.log(baseUrl, 'baseUrl')

// 创建axios实例
const instance = axios.create({
  baseURL: baseUrl, // 根据实际情况填写接口的基础URL
  timeout: 30000, // 请求超时时间
});

//请求拦截器，用于添加token到请求头
instance.interceptors.request.use(
  function (config) {
    const privyToken = localStorage.getItem("privy:token") // 从本地存储获取token，实际情况可能来源不同，比如Cookie等
    if (privyToken) {
      const token = privyToken.trim().replace(/(^"|"$)/g, '');
    // }
    // if (refreshToken) {
    //   config.headers.Authorization = `Bearer ${refreshToken}`;
    // } else if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    // if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const language = localStorage.getItem("language");
    config.headers["Accept"] = "application/json";
    if (language) {
      config.headers["lang"] = language;
    }
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");
    if (lat && lng) {
      config.headers["lat"] = lat;
      config.headers["lng"] = lng;
    }

    // config.headers["Content-Type"] = "application/json";
    console.log( config.headers["Content-Type"],'Content-Type')
    config.headers["Content-Type"] = config.headers["Content-Type"] || "application/json";
    console.log( config.headers["Content-Type"],'Content-Type1')
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器，用于统一处理接口错误
instance.interceptors.response.use(
  function (response) {
    console.log("response", response)
    if (response.status === 200) {
      return response.data;
    } else {
      toast.error(response?.status_msg || "API request failed");
      return Promise.reject(response.data);
    }
  },
  function (error) {
    // 这里可以根据接口返回的错误状态码等信息进行统一处理
    if (error.response) {
      // 接口返回了错误响应，比如400、401、404等状态码
      const statusCode = error.response.status;
      switch (statusCode) {
        case 401:
          // 比如401可能是token过期等情况，这里可以做相应的处理，如跳转到登录页面等
          //跳转到/refresh页面，刷新页面，重新获取token，把当前页面的url放到redirect_uri参数中，刷新页面
          const currentPath = window.location.pathname; // Get the current page path
          const redirectUri = encodeURIComponent(currentPath); // Encode the URL for the redirect
          window.location.href = `/refresh?redirect_uri=${redirectUri}`;
          console.log("Token may have expired, need to log in again");
          toast.error("Token may have expired, need to log in again");
          break;
        case 404:
          console.log("The requested resource does not exist");
          toast.error("The requested resource does not exist");
          break;
        default:
          console.log("An error occurred with the API, status code:", error);
          if(error?.response?.data?.detail){
            toast.error(error.response.data.detail)
          }else{
            toast.error(`An error occurred with the API, status code: ${statusCode}`);
          }
      }
    } else if (error.request) {
      // 请求发出去了但没有收到响应，比如网络问题等
      console.log("Network request failed, no response received");
      if(error.detail){
        toast.error(error.detail)
      }else{
        toast.error("Network request failed, no response received");
      }

    } else {
      // 其他情况，比如在设置请求时发生了一些错误
      console.log("Error occurred while setting up the request");
      toast.error("Error occurred while setting up the request");
    }
    return Promise.reject(error);
  }
);

// 封装get方法
function get(url, params) {
  return instance.get(url, { params });
}

// 封装post方法
function post(url, data,type) {
  console.log(type,'type')
  if(type){
    return instance.post(url, data,{headers:{"Content-Type": type}});
  }
  return instance.post(url, data);
}

export { get, post };
// 以下是使用示例，可以根据实际情况调用get和post方法去请求接口
// 比如调用get方法获取数据
// get('/api/some-get-endpoint')
//    .then(response => {
//         console.log('获取数据成功：', response.data);
//     })
//    .catch(err => {
//         console.log('获取数据失败：', err);
//     });

// // 调用post方法提交数据
// const postData = { key: 'value' };
// post('/api/some-post-endpoint', postData)
//    .then(response => {
//         console.log('提交数据成功：', response.data);
//     })
//    .catch(err => {
//         console.log('提交数据失败：', err);
//     });
